import React from "react";
import ButtonSmallIcon from "../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../types/user.types";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { useSingleUser } from "../../../hooks/useAdminUser";

export default function UserEditBtn() {
  const navigationApp = useNavigationApp();
  const {userIdFound}= useSingleUser();
  const handleClick = () => {
    if (!userIdFound) return;
    navigationApp.goToEditUser(userIdFound);
  };
  const {userRole} = useAuth();
  if (!userRole || userRole < userRoles.ADMIN) return <></>;
  
  return (
    <ButtonSmallIcon
      iconType={"edit-sheet"}
      label="Modifier"
      variant="stack"
      onClick={handleClick}
    />
  );
}
